import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "py-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-light font-roboto text-blue-700" }, "Kliiniku seaded")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "font-roboto italic font-normal text-gray-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicSettingsFields = _resolveComponent("ClinicSettingsFields")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.haveSelectedClinic)
      ? (_openBlock(), _createBlock(_component_ClinicSettingsFields, {
          key: 0,
          "active-clinic": _ctx.activeClinic
        }, null, 8, ["active-clinic"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, "Palun vali menüüst kliinik"))
  ]))
}